import React from 'react';
import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { VODCSSModules } from 'shared/utils/wix-connect';

import PropTypes from 'prop-types';

import Icon from 'shared/components/icon/icon';

import styles from './buttons.styl';


@VODCSSModules(styles)
export default class CarouselButton extends React.Component {

  static propTypes = {
    direction: PropTypes.string,
    isActive: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
  };

  static defaultProps = {
    direction: 'left',
    isActive: true,
  };

  @autobind
  handleClick(event) {
    event.preventDefault();
    this.props.onClick(event);
  }

  render() {
    const { direction, isActive } = this.props;

    const styleNames = classnames('button-container', direction, {
      inactive: isActive === false,
    });

    return (
      <div styleName={styleNames}
           onClick={this.handleClick}>
        <div styleName="button">
          <Icon styleName={`triangle-${direction}`}
                name="triangle-right" />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mobile/views/home/components/mobile-carousel/buttons.js